import { IDocument } from '@/types/unlock'
import { DocumentIcon } from '@heroicons/react/24/outline'
import React from 'react'

/**
 * A generic component that displays a list of attachments.
 * @param param0 The attachments to display.
 */
export function AttachmentList({ attachments }: { attachments: IDocument[] }) {
  return (
    <>
      {attachments?.length > 0 && (
        <ul className='m-3 list-inside grid gap-1 text-sky-700'>
          <li className='text-xs font-semibold'>Attachments:</li>
          {attachments?.map((attachment, key) => (
            <li
              key={key}
              className='flex gap-1 text-xs items-center hover:text-sky-600'
            >
              <DocumentIcon
                height={18}
                width={18}
                className='min-w-max'
              />
              <a
                href={attachment.url}
                target='_blank'
                rel='noreferrer'
              >
                {attachment.original_filename}
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
